import { alertPrefixCls } from "@/base/components/alert/Alert.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Alert">> = ({
  fontSizeIcon,
  withDescriptionFontSize,
  withDescriptionFontWeight,
  withDescriptionLineHeight,
  fontSizeCloseIcon,
  colorWarning,
  colorSuccess,
  colorError,
  colorInfo,
  withDescriptionColorIcon,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${alertPrefixCls}`]: {
      borderWidth: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",

      [`&:not(.${alertPrefixCls}-with-description)`]: {
        gap: 8,

        [`.${alertPrefixCls}-icon`]: {
          margin: 0,
          fontSize: `${fontSizeIcon}`,
        },
      },

      [`.${alertPrefixCls}-close-icon`]: {
        fontSize: `${fontSizeCloseIcon}px`,
        margin: 0,
      },

      [`&.${alertPrefixCls}-with-description`]: {
        borderWidth: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",

        [`.${alertPrefixCls}-close-icon`]: {
          maxHeight: `max-content`,
          paddingBlock: 8,
          paddingInline: 8,
        },
        [`.${alertPrefixCls}-content`]: {
          paddingBlock: 8,
          marginInlineStart: 16,
        },
        [`.${alertPrefixCls}-icon`]: {
          paddingBlock: 12,
          paddingInline: 12,
          marginInlineEnd: 0,
        },

        [`.${alertPrefixCls}-message`]: {
          margin: 0,
          fontSize: withDescriptionFontSize,
          lineHeight: withDescriptionLineHeight,
          fontWeight: withDescriptionFontWeight,
        },

        [`&.${alertPrefixCls}-warning`]: {
          [`.${alertPrefixCls}-icon`]: {
            backgroundColor: colorWarning,
            color: withDescriptionColorIcon,
          },
        },

        [`&.${alertPrefixCls}-success`]: {
          [`.${alertPrefixCls}-icon`]: {
            backgroundColor: colorSuccess,
            color: withDescriptionColorIcon,
          },
        },

        [`&.${alertPrefixCls}-error`]: {
          [`.${alertPrefixCls}-icon`]: {
            backgroundColor: colorError,
            color: withDescriptionColorIcon,
          },
        },

        [`&.${alertPrefixCls}-info`]: {
          [`.${alertPrefixCls}-icon`]: {
            backgroundColor: colorInfo,
            color: withDescriptionColorIcon,
          },
        },
      },
    },
  },
});

export const useAlertStyle = genComponentStyleHook(
  ["Alert", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
